import {lazyComponent} from 'coreUtils/adapters/lazy';

const SizeGuideFlyout = lazyComponent(() => import('./SizeGuideFlyout'));

export {SizeGuideFlyout as default};
